module.exports = __webpack_public_path__ + "static/assets/54c9026ca39fa16e462d9753dfbe4aad.png";